import React, { memo, FC, CSSProperties } from 'react';
import styled from '@emotion/styled';
import {
  Handle,
  Position,
  NodeProps,
  Connection,
  Edge,
} from 'react-flow-renderer';
import { MathJax } from 'better-react-mathjax';
import { useTranslation } from 'react-i18next';

const OutterBox = styled.div`
  background: #f9f7ed;
  border: solid 1px;
  padding: 10px 20px;
  width: 100px;
  height: 160px;
  z-index: -1;
  position: relative;
  margin-left: 9px;
`;

const EdgeTxt = styled.div`
  position: absolute;
  right: 35px;
  top: 210px;
`;

const sourceHandleStyle: CSSProperties = {
  background: 'transparent',
  border: 'none',
};

const onConnect = (params: Connection | Edge) =>
  console.log('handle onConnect', params);

const Pm: FC<NodeProps> = ({ data, isConnectable }) => {
  const { t } = useTranslation();
  // const f = "\\(\P_m \\)";
  return (
    <OutterBox>
      {/* <EdgeTxt>{t('Yes')}</EdgeTxt> */}
      <EdgeTxt>
        α<sub>c</sub>
      </EdgeTxt>
      <Handle
        type="source"
        position={Position.Bottom}
        style={sourceHandleStyle}
        isConnectable={isConnectable}
      />
      {/* <MathJax>{f}</MathJax> */}
      <MathJax>
        ρ<sub>c|s,X</sub>
      </MathJax>
    </OutterBox>
  );
};

export default memo(Pm);
